module.exports = __webpack_public_path__ + "static/img/2.05f90173.jpg";